export default __webpack_public_path__ + "static/media/PP.f0631883.jpeg";